import { DeepReadonly } from 'utility-types';

export type LearnersEmailConsentState = DeepReadonly<{
  hasEnrolmentConsentPermission: boolean;
  isFetchingHasEnrolmentConsentPermission: boolean;

  isUpdatingHasEnrolmentConsentPermission: boolean;
  updateHasEnrolmentConsentPermissionError: string | null;
}>;

export const INITIAL_STATE: LearnersEmailConsentState = {
  hasEnrolmentConsentPermission: true,
  isFetchingHasEnrolmentConsentPermission: false,

  isUpdatingHasEnrolmentConsentPermission: false,
  updateHasEnrolmentConsentPermissionError: null,
};
